function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from "./Icon";

var Dialog = function Dialog(props) {
  return React.createElement(Icon, _extends({
    color: "#ffffff",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M17.75 0.25C18.8546 0.25 19.75 1.14543 19.75 2.25V12.6336C19.75 13.7382 18.8546 14.6336 17.75 14.6336H16.5C16.2239 14.6336 16 14.8575 16 15.1336V18.7436C16 19.1568 15.5273 19.3917 15.198 19.1421L9.25 14.6336H2.25C1.14543 14.6336 0.25 13.7382 0.25 12.6336V2.25C0.25 1.14543 1.14543 0.25 2.25 0.25H17.75Z"
  }));
};

export default Dialog;